import { clearListCache, createKey, get } from "@/utils/networkCache";
import { request } from "leatherman-js";
import Status from "@/classes/Status";

const CACHE_PLURAL_KEY = "stencils";

const stencils = {
  namespaced: true,
  state: {
    status: new Status(),
    list: [],
    sort: null,
    planId: null,
  },
  mutations: {
    SET_STATUS(state, payload) {
      state.status.value = payload;
    },
    SET_LIST(state, payload) {
      state.list = payload;
    },
    SET_PLAN_ID(state, payload) {
      state.planId = payload;
    },
  },
  actions: {
    async getList({ commit, dispatch }, { planId }) {
      commit("SET_STATUS", Status.LOADING);
      commit("SET_PLAN_ID", planId);

      try {
        const { list } = await dispatch("sites/getList", { planId }, { root: true });

        // create request to get stencils for each site in list
        const responses = list.map((site) =>
          get(createKey(CACHE_PLURAL_KEY, { siteId: site.id }), request.makeParse, [
            "getStencils",
            { siteId: site.id },
          ])
        );
        // resolve each response
        const resolvedList = await Promise.all(responses);

        // concatenate all responses into one long list
        let stencils = [];
        resolvedList.forEach((list) => {
          stencils = [...stencils, ...list];
        });

        commit("SET_LIST", stencils);
        commit("SET_STATUS", Status.LOADED);

        return stencils;
      } catch (e) {
        commit("SET_STATUS", Status.ERROR);
      }
    },
    create(context, { siteId, name }) {
      return request.makeParse("createStencil", { siteId }, { name });
    },
    delete(context, { stencilId, siteId }) {
      return request.makeParse("deleteStencil", { siteId, stencilId });
    },
    async refreshList({ dispatch, state }) {
      const planId = state.planId;

      // clear all the stencil caches for every site, ... ugh
      const { list } = await dispatch("sites/getList", { planId }, { root: true });
      list.forEach((site) => {
        clearListCache(createKey(CACHE_PLURAL_KEY, { siteId: site.id }));
      });

      dispatch("getList", { planId });
    },
  },
  getters: {
    get: (state) => (id) => state.list.find((item) => item.id === id),
    getList: (state) => state.list,
    getListStatus: (state) => state.status,
  },
};

export default stencils;
